export default [
  {
    path: '/comisiones-sedes',
    name: 'comisiones-sedes',
    component: () => import('@/views/comisiones/sedes/SedesLayout.vue'),
  },
  {
    path: '/comisiones-instituciones',
    name: 'comisiones-instituciones',
    component: () => import('@/views/comisiones/instituciones/InstitucionesLayout.vue'),
  },
  {
    path: '/comisiones-tipos-documentos-persona',
    name: 'comisiones-tipos-documentos-persona',
    component: () => import('@/views/comisiones/tipos-documentos-persona/TiposDocumentosPersonaLayout.vue'),
  },
  {
    path: '/comisiones-inscripciones-productividad',
    name: 'comisiones-inscripciones-productividad',
    component: () => import('@/views/comisiones/inscripciones-productividad/InscripcionesProductividadLayout.vue'),
  },
];
